<template>
  <div>
    <div class="topBar">
      <div class="left">
        <img :src="logo" alt="">
        <div class="navBar">
          <div class="navItem pointer" v-for="(item, index) in navList" :key="index" @click="gotoRoute(item.label)">
            <img :src="fetchCurrentRoute(item.label)?item.srcAct:item.src" alt="">
            <div class="label" :class="{'labelAct': fetchCurrentRoute(item.label)}">{{$t(`lang.menu.${item.label}`)}}</div>
          </div>
          <div class="navItem depositAndWithdraw pointer" @click="gotoRoute('Setting/Deposit')">
            <img :src="depositAct" alt="">
            <div class="label">{{$t('lang.menu.Deposit')}}</div>
          </div>
          <div class="navItem depositAndWithdraw pointer" @click="gotoRoute('Setting/Withdraw')" v-if="isLogin">
            <img :src="withdrawAct" alt="">
            <div class="label">{{$t('lang.menu.Withdraw')}}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="locale pointer"
            @click="onShowCountryDDL">
          <span class="loc-tag tag">{{ locale === 'EN' ? 'ENG' : internationName }}</span>
          <div class="tag">
            <img :src="triangle" class="local-img" alt="">
          </div>
        </div>
        <div class="download">
          <div>
            <img class="andimg pointer" :src="popupChange" alt="" @click="popup()">
          </div>
        </div>
        <!-- <div class="locale pointer" v-if="!isLogin">
          <div v-for="(item, index) in countryList" :key="index"
               @click="onShowCountryDDL"
               v-show="item.CountryCode == $store.state.internation && $store.state.showInternationDDL"
               style="display: flex;font-size: 16px">
            <img :src="require('../../../static/images/'+item.CountryCode+'.png')" class="countryIcon" />
            <span style="margin-right: 5px;">{{item.CountryNameLocal}}</span>
            <img :src="triangle" :class="{rotate: showCountryDDL}" alt="">
          </div>
          <div class="selectList" v-show="showCountryDDL">
            <div class="option pointer"
                 v-for="(item, index) in countryList"
                 :key="index" @click="selectCountry(item)">
              <img :src="require('../../../static/images/'+item.CountryCode+'.png')" class="countryIcon" />
              <span>{{item.CountryNameLocal}}</span>
            </div>
          </div>
        </div> -->
        <div class="login pointer" @click="login" v-if="!isLogin">
          {{$t('lang.login.login')}}
        </div>
        <div class="userInfo" v-else>
          <div class="cash_bonus" @mouseenter="toggleDisplay('showBonus', true)" @mouseleave="toggleDisplay('showBonus')">
            <div class="cash">
              <img :src="cashAct" alt="">
              <div>
                {{fetchCurrency[userInfo.CurrencyName]}}
                {{separateThousand($store.state.balance.Total)}}
              </div>
            </div>
          </div>
          <div class="user" @mouseenter="toggleDisplay('showMenu', true)" @mouseleave="toggleDisplay('showMenu')">
            {{userInfo.UserName}}
            <img :src="triangle" alt="" :class="{rotate: showMenu}">
            <div class="menu" :class="{opacity: changeOpacity}" v-show="showMenu">
              <div class="menuItem" v-for="(item, index) in menuList" :key="index" @click="gotoRoute(item.href)">
                <img :src="newMail?mailNew:mail" alt="" v-if="item.src === 'message'">
                <img :src="item.src" alt="" v-else>
                <div class="label">{{item.label}}</div>
              </div>
            </div>
          </div>
          <img class="pointer" :src="newMail?mailNew:mail" alt="" @click="$router.push('/Setting/Message')">
          <div class="internation" v-if="this.$store.state.internation !== 'IN'">
            <img :src="require('../../../static/images/'+this.$store.state.internation+'.png')" class="countryIcon" />
            <span>{{this.$store.state.internationName}}</span>
          </div>
        </div>
      </div>
    </div>
    <Login v-if="$store.state.showLogin"/>
    <LoginEmail v-if="$store.state.showLoginEmail"/>
    <DownAppPopup v-if="$store.state.showPopupDownApp"/>
    <div :class="{'language-mask': showCountryDDL}" v-show="showCountryDDL" @click="closeLanguageSelect">
      <div class="language-container">
        <div class="language-top">
          <!-- <div>Language</div> -->
          <img :src="languagePng" alt="language">
        </div>
        <div class="selectList">
          <div class="option pointer select-row"
                :class="{'selectactive':locale == item.Language}"
                v-for="(item, index) in countryList"
                :key="index" @click="selectCountry(item)">
            <img :src="require('../../../static/images/'+item.Language+'.png')" class="countryIcon" />
            <span>{{item.CountryNameLocal}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/common/logo1.svg'
// import home from '@/assets/images/TopGuide/home.svg'
// import homeAct from '@/assets/images/TopGuide/homeAct.svg'
import games from '@/assets/images/TopGuide/games.svg'
import gamesAct from '@/assets/images/TopGuide/gamesAct.svg'
import promotion from '@/assets/images/TopGuide/promotion.svg'
import promotionAct from '@/assets/images/TopGuide/promotionAct.svg'
import FAQ from '@/assets/images/TopGuide/FAQ.svg'
import withdrawAct from '@/assets/images/TopGuide/withdrawAct.svg'
import FAQAct from '@/assets/images/TopGuide/FAQAct.svg'
import depositAct from '@/assets/images/TopGuide/depositAct.svg'
import bonusAct from '@/assets/images/TopBar/bonusAct.svg'
import cashAct from '@/assets/images/TopBar/cashAct.svg'
import mail from '@/assets/images/Menu/messageAct.svg'
import mailNew from '@/assets/images/TopBar/mailNew.svg'
import account from '@/assets/images/Menu/accountAct.svg'
import editInfo from '@/assets/images/Menu/editInfoAct.svg'
import history from '@/assets/images/Menu/historyAct.svg'
import triangle from '@/assets/images/common/triangle.svg'
import andDownload from '@/assets/images/common/andDownload.png'
import LoginEmail from '@/components/LoginEmail/index'
import Login from '@/components/Login/index'
import DownAppPopup from '@/pages/Message/DownApp'
import popupClick from '@/assets/images/common/popupclick.png'// for India and Global
import popupClickv from '@/assets/images/common/popupclickv.png'// for Vietnam
import {separateThousand, fetchBalance, Storage} from '@/utils'
import request from '@/service'
import languagePng from '@/assets/images/common/language.png'
import {fetchCurrency} from '@/constant'
import {mapMutations} from 'vuex'
import store from '../../store/store'

export default {
  name: 'TopBar',
  data () {
    return {
      logo,
      andDownload,
      languagePng,
      navList: [
        // {
        //   label: 'Home',
        //   src: home,
        //   srcAct: homeAct
        // },
        {
          label: 'Games',
          src: games,
          srcAct: gamesAct
        },
        {
          label: 'Promotion',
          src: promotion,
          srcAct: promotionAct
        },
        {
          label: 'FAQ',
          src: FAQ,
          srcAct: FAQAct
        }
      ],
      menuList: [
        {
          label: this.$t('lang.menu.Account'),
          src: account,
          href: 'Setting/Account'
        },
        {
          label: this.$t('lang.menu.Edit'),
          src: editInfo,
          href: 'Setting/Edit'
        },
        {
          label: this.$t('lang.menu.History'),
          src: history,
          href: 'Setting/History'
        },
        {
          label: this.$t('lang.menu.Message'),
          src: 'message',
          href: 'Setting/Message'
        }
      ],
      withdrawAct,
      depositAct,
      bonusAct,
      cashAct,
      mail,
      mailNew,
      triangle,
      separateThousand,
      fetchBalance,
      fetchCurrency,
      isLogin: !!localStorage.getItem('userInfo'),
      showLogin: false,
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
      showBonus: false,
      changeOpacity: false,
      newMail: false,
      showMenu: false,
      internationName: localStorage.getItem('internationName') === 'English' ? 'ENG' : localStorage.getItem('internationName'),
      locale: localStorage.getItem('locale') === null ? 'ENG' : localStorage.getItem('locale'),
      countryList: [],
      showCountryDDL: false,
      popupChange: this.$store.state.internation.toLowerCase() === 'vn' ? popupClickv : popupClick // for pop up given the campain
    }
  },
  components: {
    Login,
    LoginEmail,
    DownAppPopup
  },
  mounted () {
    if (localStorage.getItem('userInfo')) {
      this.fetchBalance()
      this.fetchUnreadCount()
      setInterval(() => {
        this.fetchBalance()
        this.fetchUnreadCount()
      }, 30000)
    }

    this.getInternationCountryList()

    if (this.$route.query.rv) {
      store.commit('toggleLoginEmail', true)
      store.commit('setLoginStatus', 'reset')
    }
  },
  computed: {
    fetchCurrentRoute () {
      return (label) => {
        return label === this.$route.name || (this.$route.name && label && this.$route.name.toLowerCase() === 'home' && label.toLowerCase() === 'games')
      }
    }
  },
  methods: {
    ...mapMutations({
      toggleLogin: 'toggleLogin',
      setCurrentRoute: 'setCurrentRoute',
      setInternation: 'setInternation',
      setInternationName: 'setInternationName',
      setLocale: 'setLocale'
    }),
    toggleDisplay (method, status) {
      if (status) {
        this[method] = true
        setTimeout(() => {
          this.changeOpacity = true
        }, 10)
      } else {
        this.changeOpacity = false
        setTimeout(() => {
          this[method] = false
        }, 200)
      }
    },
    closeLanguageSelect (e) {
      this.showCountryDDL = false
      e.stopPropagation()
    },
    gotoRoute (label) {
      if (this.$store.state.currentRoute === label || (this.$store.state.currentRoute.toLowerCase() === 'home' && label === 'Games')) {
        return
      }
      if (label === 'Setting/Deposit' && !this.isLogin) {
        // this.showLogin = true
        this.toggleLogin(true)
        return
      }
      if (label.toLowerCase() === 'games') {
        label = 'Home'
      }
      this.setCurrentRoute(label)
      this.$router.push('/' + label)
    },
    fetchUnreadCount () {
      const url = '/innovation/message/getnotreadmessagescount'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request('post', url, data, true).then(res => {
        if (res.NotReadMessagesCount) {
          res.NotReadMessagesCount.forEach(item => {
            if (item.Count > 0) this.newMail = true
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    close () {
      // this.showLogin = false
      this.toggleLogin(false)
    },
    // 2021-08-29 C007 获取国际化-国家列表
    getInternationCountryList () {
      const url = '/innovation/internal/getinternationcountrylist'
      const data = {
      }
      request('post', url, data, false)
        .then(res => {
          this.countryList = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    onShowCountryDDL () {
      this.showCountryDDL = !this.showCountryDDL
    },
    /***
     * 选择国家版本
     * @param internation
     */
    selectCountry (internation) {
      this.showCountryDDL = !this.showCountryDDL
      this.setInternation(internation.CountryCode)
      // 2021-10-31 CHP 增加设置国家版本名字、语言
      this.setInternationName(internation.CountryNameLocal)
      localStorage.setItem('locale', internation.Language)
      this.locale = internation.Language
      this.$i18n.locale = internation.Language // localStorage.getItem('locale') // todo 切换版本
      this.$store.commit('setLocale', internation.Language)
      Storage.setExpire('locale', internation.Language, 7 * 24 * 3600)
      window.location.reload()
    },
    login () {
      store.commit('toggleLogin', true)
      store.commit('setLoginStatus', 'login')
    },
    popup () {
      this.$store.state.showPopupDownApp = true
    }
  }
}
</script>

<style lang="less" scoped>
.language-mask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.3);
  z-index: 101;
  .language-container{
    box-sizing: border-box;
    position: fixed;
    width: 280px;
    height: 170px;
    left: calc(50% - 140px);
    top: calc(50% - 80px);
    background: radial-gradient(41.41% 50% at 50% 50%, #2D2D2D 0%, #261C1C 100%);
    box-shadow: inset 0px 4px 13px 5px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    border: 1px solid;
    border-color: #8C8C8C;
    .language-top{
      width: 100%;
      padding: 10px 7px 7px 7px;
      border: 1px solid;
      border-radius: 8px 8px 0 0;
      border-color: #8C8C8C;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        height: 30px;
      }
      div{
        width: fit-content;
        margin: auto;
        text-align: center;
      }
    }
    .selectList {
      width: 100%;
      padding: 10px 0;
      text-align: left;
      z-index: 5;
      .option {
        padding: 1px 10px;
        margin: 5px 0;
        display: flex;
        width: 100%;
        font-family: 'Arial';
        font-style: normal;
        font-weight: 220;
        font-size: 22px;
        line-height: 30px;
        letter-spacing: 0.01em;
        align-items: center;
        .countryIcon {
          height: 36px;
          width: 36px;
          margin: 2px 22px 2px 20px;
          display: block;
        }
        span {
          height: 30px;
        }
      }
      .selectactive{
        color: #fff;
        background: linear-gradient(89.95deg, rgba(217, 217, 217, 0) -1.46%, #8d8d8d 54.88%, rgba(116, 116, 116, 0) 96.92%);
      }
    }
  }
}
  .topBar {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 45px 20px 45px 20px;
    .left {
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        height: 45px;
      }
      .navBar {
        display: flex;
        align-items: center;
        margin-left: 35px;
        .navItem {
          display: flex;
          align-items: center;
          margin-right: 15px;
          img {
            width: 30px;
            margin-right: 5px;
          }
          .label {
            font-size: 18px;
            color: #686868;
          }
          .labelAct {
            color: #F6D9AA;
            font-weight: bold;
          }
        }
        .depositAndWithdraw {
          padding: 0 12px;
          height: 40px;
          background-color: #FFE39B;
          border-radius: 6px;
          .label {
            color: #8C5400;
          }
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 10px;
      .login {
        text-align: center;
        width: 100px;
        background-color: #F6D9AA;
        border-radius: 17px;
        line-height: 34px;
        font-size: 14px;
        color: #202020;
      }
      .locale {
        line-height: 32px;
        padding: 0 6px;
        display: flex;
        width: 68px;
        color: #F6D9AA;
        border: 1px solid #F6D9AA;
        border-radius: 5px;
        justify-content: space-between;
        margin-right: 30px;
        /*border-radius: 50%;*/
        .tag{
          display: inline-flex;
          font-size: 16px;
          text-align: center;
          align-content: center;
          align-items: center;
          justify-content: center;
          .local-img{
            height: 12px;
            width: 12px;
          }
        }
        .countryIcon {
          height: 20px;
          width: 20px;
          margin: 2px 10px 2px 0px;
          display: block;
        }
        .rotate {
          transform: rotateZ(90deg);
        }
      }
      .userInfo {
        display: flex;
        align-items: center;
        .cash_bonus {
          margin-right: 25px;
          width: 150px;
          .cash, .bonus {
            display: flex;
            align-items: center;
            img {
              margin-right: 10px;
            }
            div {
              width: 200px;
              border-radius: 4px;
              font-size: 16px;
              line-height: 24px;
              padding: 0 5px;
              text-align: right;
            }
            &:not(:first-child) {
              margin-top: 5px;
            }
          }
          .cash {
            div {
              color: #F6D9AA;
              border: 1px solid #F6D9AA;
            }
          }
          .bonus {
            opacity: 0;
            transition: opacity .3s;
            div {
              color: #8C5400;
              background: #FFE39B;
            }
          }
          .opacity {
            opacity: 1;
          }
        }
        .user {
          position: relative;
          margin-right: 7px;
          font-size: 18px;
          line-height: 40px;
          color: #F6D9AA;
          cursor: default;
          white-space:nowrap; // 强制不换行
          >img {
            margin-left: 5px;
            transition: transform .5s;
          }
          .rotate {
            transform: rotateZ(90deg);
          }
          .menu {
            position: absolute;
            top: 35px;
            left: -60px;
            width: 200px;
            padding: 14px 23px;
            background-color: #000;
            opacity: 0;
            transition: opacity .3s;
            z-index: 1;
            cursor: default;
            .menuItem {
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              cursor: pointer;
              img {
                width: 24px;
                margin-right: 18px;
              }
              .label {
                font-size: 18px;
                color: #F6D9AA;
              }
            }
          }
          .opacity {
            opacity: 1;
          }
        }
        .internation{
          margin-left: 15px;
          display: flex;

          .countryIcon {
            height: 20px;
            width: 20px;
            margin: 2px 10px 2px 0px;
            display: block;
          }
        }
      }
    }
    .download{
      margin-right: 40px;
      padding-top: 5px;
      .andimg{
        width: 150px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TopBar/index.vue